import React, { useState, useEffect } from 'react';
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import './Data_Quaility_Framework.css'


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation, BsTransparency } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Data_Quaility_Framework = () => {
    


    const goals = [
        {
            goal: 'Within the context of AI, the overall goal of a data quality processing framework is to ensure that the data used for training, testing, and deploying AI models is of the highest quality. This is critical because the performance, accuracy, and fairness of AI models are directly dependent on the quality of the input data.',
            PreGoal:'Goal DQ1:',
            description: 'AI systems are designed to be inclusive in accordance with any Accessibility Standards.',
            text2: 'Designing inclusive AI systems that adhere to accessibility standards requires a multi-faceted approach, encompassing considerations throughout the entire development lifecycle:',
            requirements: [
                {
                    id: 'Data Quality Dimensions:',
                    s1: 'The framework defines key dimensions of data quality such as accuracy, completeness, consistency, timeliness, and relevance. These dimensions help organizations assess and monitor the quality of their data across different use cases.',
                }, 
                {
                    id: 'Data Quality Requirements:',
                    s1: 'Organizations must establish clear data quality requirements that align with business needs and regulatory standards. These requirements serve as benchmarks for evaluating and improving data quality.',
                },
                {
                    id: 'Data Quality Assessment:',
                    s1: 'The framework outlines processes for assessing data quality against predefined criteria. This includes methods for detecting data anomalies, measuring data quality metrics, and identifying areas for improvement.',
                },
                {
                    id: 'Data Quality Improvement:',
                    s1: 'ISO 5259-4:2024 emphasizes continuous improvement in data quality. It provides guidance on implementing corrective actions, refining data quality processes, and ensuring that improvements are sustainable over time.',
                },
                {
                    id: 'Data Governance and Stewardship:',
                    s1: 'The framework integrates data governance practices, ensuring that roles and responsibilities for data quality management are clearly defined. This includes the establishment of data stewards who are accountable for maintaining data quality.',
                },
                {
                    id: 'Data Quality Tools and Techniques:',
                    s1: 'The standard discusses various tools and techniques for data quality management, including data profiling, cleansing, validation, and enrichment. It encourages the use of automated tools to enhance efficiency and accuracy in data processing.',
                },
                {
                    id: 'Documentation and Reporting:',
                    s1: 'Comprehensive documentation of data quality processes and outcomes is required. The framework also stresses the importance of transparent reporting to stakeholders, ensuring that data quality initiatives are well-communicated and understood.',
                },
               

            ]
        },
    ];
 



    const goal = goals[0];


    return (
        <div style={{ backgroundColor: 'rgb(240, 242, 245)', height: '100%' }}>
          <div className='dashcontent'>
            <div>
                <h2>Data Quality Processing Framework</h2>
            </div>
            <h2 className="goal-title">
              <span className="goal-prefix">{goal.PreGoal}</span> <span className="DQ-goal-name">{goal.goal}</span>
            </h2>
            <strong>Key Objectives Include:</strong>
            <ul>
                <li>Enhancing Model Accuracy: Ensuring that data used to train AI models is accurate, consistent, and relevant helps improve the predictive power and reliability of the models.</li>
                <li>Reducing Bias: A high-quality data framework identifies and mitigates biases in the data, leading to fairer AI outcomes. This is particularly important in sensitive areas like healthcare, hiring, and lending, where biased data can lead to unethical decisions.</li>
                <li>Ensuring Data Completeness: Incomplete data can lead to poor model performance. A data quality framework ensures that the data is comprehensive, which is essential for building robust AI models.</li>
                <li>Improving Data Consistency: Consistency across datasets ensures that AI models can generalize well to new, unseen data. This is crucial for deploying AI models in real-world scenarios.</li>
                <li>Compliance and Governance: The framework ensures that the data used in AI models complies with relevant regulatory requirements, such as GDPR, and adheres to organizational data governance policies.</li>
            </ul>
            <p>ISO 5259-4:2024 focuses on the data quality processing framework, providing guidelines and standards for managing and improving data quality within organizations. This standard is part of a broader series (ISO 5259) that addresses data quality management across various dimensions.</p>
            <strong>Key Components of the Data Quality Processing Framework in ISO 5259-4:2024:</strong>
    
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="assessment-table">
                <thead>
                  <tr>
                    <th className="DQ-requirements-header">Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {goal.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                      <td className="requirement-text">
                        <strong>{requirement.id}</strong>
                        <br/>{requirement.s1}
                      </td>
                    </tr>
                  ))}
                <hr className='requirement-row'/>
                <p className="requirement-text">By following the ISO 5259-4:2024 framework, organizations can systematically manage data quality, leading to more reliable data for decision-making, improved compliance with regulatory requirements, and enhanced overall business performance.</p>
                </tbody>
              </table>              
            </div>
          </div>
        </div>
      );
};

    

export default Data_Quaility_Framework;